export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00666.99ba1d97.png";